import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Frame = styled(Box)``;

export const Player = styled('iframe')``;
